new window.Swiper("#useful-links-mobile", {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".useful-links-next",
    prevEl: ".useful-links-prev",
  },
  breakpoints: {
    991: {
      slidesPerView: 3,
      enabled: false,
      centerInsufficientSlides: true,
    },
  },
});
